var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import clsx from 'clsx';
import { useClasses, useLayoutProps, useProps } from '@hawkins/helpers';
import { Box } from '../box/box';
import { useCardBodyStyles } from './cardBody.styles';
var displayName = 'CardBody';
/**
 * The CardBody component is the main content container for the Cards.
 *
 * CardBody does have overflow set to `auto`, so it is up to you to set the maxHeight.
 */
export var CardBody = forwardRef(function (props, ref) {
    var _a;
    // Props
    var _b = useProps(displayName, props), className = _b.className, classesProp = _b.classes, children = _b.children, styleProp = _b.style, _c = _b.component, component = _c === void 0 ? 'div' : _c, _d = _b.square, square = _d === void 0 ? false : _d, _e = _b.fullScreen, fullScreen = _e === void 0 ? false : _e, layout = _b.layout, rest = __rest(_b, ["className", "classes", "children", "style", "component", "square", "fullScreen", "layout"]);
    // Styles
    var baseClasses = useCardBodyStyles();
    var classes = useClasses(displayName, baseClasses, classesProp);
    var rootClassName = clsx(classes.HAWKINS_BASE, classes.root, className, (_a = {},
        _a[classes.rootFullScreen] = fullScreen,
        _a[classes.rootSquare] = square,
        _a));
    var style = useLayoutProps({ layout: layout, style: styleProp });
    return (_jsx(Box, __assign({ className: rootClassName, component: component, ref: ref, style: style }, rest, { children: children })));
});
CardBody.displayName = displayName;
